import { createRouter, createWebHistory } from 'vue-router'
import { getCurrentUser } from 'vuefire'
import { routes } from './routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, _, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach(async (to, _, next) => {
  const isRouteProtected = to.meta.requiresAuth
  const isUserLogged = await getCurrentUser()

  if (isRouteProtected && !isUserLogged) {
    return next({ name: 'login' })
  }

  const isRouteToAuth = to.meta.authRoutes

  if (isRouteToAuth && isUserLogged) {
    return next({ name: 'inicio' })
  }

  return next()
})

export default router
